const strDateToShort = ( strDate ) => {

    const d = new Date(strDate);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month].join('/');
}

function strDateToYYYYMMDD(strDate) {
    const d = new Date(strDate);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

function strDateToDDMMYYYY(strDate) {
    const d = new Date(strDate);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
}

export { strDateToShort, strDateToDDMMYYYY, strDateToYYYYMMDD };